import { Note } from "../../../Data/HexMap/Note";
import { Music, usePentatonicScaleNotes } from "../../../Util/Music/Music";
import { ChapterConfig } from "../../ChapterConfig";
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox";
import { ChapterNav, ChapterNavItem } from "../ChapterNav/ChapterNav";
import { ChapterRoutes } from "../ChapterNav/ChapterRoutes";
import { ClearHelpers } from "../../Helpers/ClearHelpers/ClearHelpers";
import { HxMapGroup } from "../../../Comps/HxMap/HxMapGroup";
import { BuildHexMap} from "../../../Data/HexMap/HexMapBuilder";
import { HexMap } from "../../../Data/HexMap/HexMap";
import { TransformTranslate } from "../../../Util/Transform/Transform";
import { MutableRefObject, useRef, useState } from "react";
import { ExerciseMessage } from "../../Exercises/Utils/Message/ExerciseMessage";
import { NotePlayer } from "../../../Sound/NotePlayer";
import { useNotePlayer } from "../../../Sound/SoundStore";
import { LinearScale } from "../../../Comps/LinearKey/LinearScale";
import { NotesSelectMenu } from "../../../Comps/NoteButtons/NotesSelect";

export function PentatonicScaleChapter(props:ChapterConfig){
    const subPaths:ChapterNavItem[] = [
        {title:'Lesson', path:'lesson', element:<ClearHelpers><Lesson/></ClearHelpers>}
    ]
    return  <div>
                <h1>The Pentatonic Scale</h1>
                <ChapterNav path={props.path} subPaths={subPaths}/>
                <ChapterRoutes chapterNavs={subPaths}/>
            </div>
}

export function Lesson(){
    const notePlayer:MutableRefObject<NotePlayer> = useRef(useNotePlayer())
    const lastNoteTime:MutableRefObject<number> = useRef(0)
    const modeNames:string[] = ['Major Pentatonic', 'Suspended Pentatonic', 'Blues Minor Pentatonic', 'Blues Major Pentatonic', 'Minor Pentatonic']
    const visibleNotes:number[] = [0,1,2,4,5]
    const radius:number = 130
    const width:number = radius * 2.8
    const height:number = radius * 2.8
    const [tonic, setTonic] = useState<number>(Music.C)
    const [offset, setOffset] = useState<number>(0)
    const onNoteClick = (note:Note) => {
        const currTime:number = Date.now()
        const reset:boolean = ((currTime - lastNoteTime.current) > 3000)
        lastNoteTime.current = currTime
        notePlayer.current.playNote(note.params.tonic, reset)
    }
    const getMap = () => {  
        // const displayConfig:DisplayConfig = new DisplayConfig({keyRadius: radius, noteRadiusToKeyRadius:.25})  
        //const mapData:HexMap = BuildHexMap({noteDisplayConfig:displayConfig, columns:1, rows:1, tonic:tonic, radius:radius})
        const mapData:HexMap = BuildHexMap({columns:1, rows:1, tonic:tonic, radius:radius})

        mapData.notes.forEach((note:Note, index:number)=>{
            const scaleIndex:number = visibleNotes.indexOf(index)
            const defined:boolean = (scaleIndex > -1)
            note.defined = defined
            if(defined){
                note.selectedState = (scaleIndex === offset) ? Note.SelectedState_Hilited : Note.SelectedState_Selected
            }
        })
        return mapData
    }
    const onButtonClick = (modeIndex:number) => {
        setOffset(modeIndex)
    }
    const modeNotes:string[] = usePentatonicScaleNotes(tonic, offset, true)
    const ModeButtons = () => {
        const getClassName = (index:number) => {
            if(index === offset){
                return 'selected'
            }
            return undefined
        }
        return(
            <div className={'pentatonic-mode-buttons'}>
                {modeNotes.map((noteName:string, index:number)=>{
                    if(index === 5){return null}
                    return <button key={index} className={getClassName(index)} type={'button'} onClick={()=>{onButtonClick(index)}}>{modeNames[index]}</button>
                })}
            </div>
    )
    }
    const onTonicChange = (t:number) => {
        setTonic(t)
    }
    return(
        <OutlineBox title={'The Pentatonic Scale'} width={600}>
            <div className={'Lesson'}>
                <NotesSelectMenu tonic={tonic} onChange={onTonicChange}/>
                    <ExerciseMessage answerStatus={null} message={(offset + 1 + ': ') + modeNames[offset]}/>
                        <svg width={width} height={height}>
                            <g transform={TransformTranslate(width/2, height/2)}>
                                <HxMapGroup hexMap={getMap()} onNoteClick={onNoteClick}/>
                                {/* <HxNote classNames={['blue-note']} note={getBlueNote()} onNoteClick={()=>{}}/> */}
                            </g>
                        </svg>
                        <LinearScale noteNames={modeNotes}/>
                        <ModeButtons/>
                    </div>
        </OutlineBox>
    )
}
